import React from 'react'
import './samples-bar-header.scss'
import Button from '../../atoms/Button/Button';

const SamplesBarHeader = props => {
    return (
        <div className={props.countryHaveSamples ? (props.samplesBarVisibility ? "f-samples-header" : "f-samples-header f-samples-header--hide") : "f-samples-header f-samples-header--hide"}>
            <div className="f-samples-header-content">
                {
                    props.countryHaveSamples ?
                        <>
                            <p>{props.barText}</p>
                            <Button
                                type="button"
                                classname={props.samplesBarVisibility ? "f-button f-button--success" : "f-button f-button--success f-button--hide"}
                                text={props.samplesText}
                                value={props.samplesText}
                                onClickAction={() => window.location.href = props.homeLink + props.samplesRedirection}
                            />
                        </>
                        :
                        null
                }
            </div>
        </div>
    )
};

export default SamplesBarHeader;